/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { DownloadPurposeEnum } from '../models/DownloadPurposeEnum';
import { PlatformEnum } from '../models/PlatformEnum';
import { HttpFile } from '../http/http';

export class UserExtradataRequest {
    'platform'?: PlatformEnum;
    'whereDidTheyHear'?: string;
    'downloadPurpose'?: DownloadPurposeEnum;
    'offerCodes'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "platform",
            "baseName": "platform",
            "type": "PlatformEnum",
            "format": ""
        },
        {
            "name": "whereDidTheyHear",
            "baseName": "whereDidTheyHear",
            "type": "string",
            "format": ""
        },
        {
            "name": "downloadPurpose",
            "baseName": "downloadPurpose",
            "type": "DownloadPurposeEnum",
            "format": ""
        },
        {
            "name": "offerCodes",
            "baseName": "offerCodes",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return UserExtradataRequest.attributeTypeMap;
    }

    public constructor() {
    }
}



